import React from 'react';
import PropTypes from 'prop-types';
import { AssessmentQuiz, AssessmentResult, Form, LandingPage } from '..';

const Router = props => {
  const { route, goToRoute, getScore, onAnswerClicked, onFormSubmit } = props;

  switch (route) {
    case '/form':
      return <Form onFormSubmit={onFormSubmit} />;

    case '/results':
      return <AssessmentResult score={getScore()} />;

    case '/tool-1':
      return (
        <AssessmentQuiz
          page={1}
          goToPrevious={() => goToRoute('/')}
          goToNext={() => goToRoute('/tool-2')}
          onAnswerClicked={onAnswerClicked}
        />
      );

    case '/tool-2':
      return (
        <AssessmentQuiz
          page={2}
          goToPrevious={() => goToRoute('/tool-1')}
          goToNext={() => goToRoute('/tool-3')}
          onAnswerClicked={onAnswerClicked}
        />
      );

    case '/tool-3':
      return (
        <AssessmentQuiz
          page={3}
          goToPrevious={() => goToRoute('/tool-2')}
          goToNext={() => goToRoute('/tool-4')}
          onAnswerClicked={onAnswerClicked}
        />
      );

    case '/tool-4':
      return (
        <AssessmentQuiz
          page={4}
          goToPrevious={() => goToRoute('/tool-3')}
          goToNext={() => goToRoute('/form')}
          onAnswerClicked={onAnswerClicked}
        />
      );

    default:
      return <LandingPage />;
  }
};

Router.propTypes = {
  route: PropTypes.string,
  goToRoute: PropTypes.func,
  getScore: PropTypes.func,
  onAnswerClicked: PropTypes.func,
  onFormSubmit: PropTypes.func
};

Router.defaultProps = {
  route: '/',
  goToRoute: () => {},
  getScore: () => 0,
  onAnswerClicked: () => {},
  onFormSubmit: () => {}
};

export default Router;



// WEBPACK FOOTER //
// ./src/pages/gdpr-assessment-tool/containers/Router/Router.js